import React from "react";
import { CircleButton } from "_c/button";
import styled from "styled-components";
import socialsList from "@/misc/socials-auth-list";
import { getAffiliateCode } from "@/utils";
import { motion } from "framer-motion";
import qs from "query-string";
import { analyticsAction } from "@/utils/analytics";
import { useYandexMetrikaClientId } from "@/hooks/useYandexMetrikaClientId";

const List = motion(styled.ul`
  display: flex;
  justify-content: center;
`);
const Item = motion(styled.li`
  margin: 0 4px;
`);
const listVariants = {
  show: {
    transition: {
      staggerChildren: 0.175,
    },
  },
};
const itemVariants = {
  hidden: { opacity: 0, y: -20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};
const Socials = ({
  isMaster,
  isClient,
  isSaloonOwner,
  affiliateData,
  action,
  locale,
  timezone,
}) => {
  const ym_client_id = useYandexMetrikaClientId();
  const code = affiliateData && getAffiliateCode({ isMaster, affiliateData });
  const onClick = (provider) => {
    const event = {
      google: "google_auth_click",
      vk: "login_vk_click",
    }[provider];
    if (event) {
      analyticsAction({
        category: "reg",
        action: event,
      });
    }
  };
  return (
    <div style={{ width: "100%" }}>
      <List initial="hidden" animate="show" variants={listVariants}>
        {socialsList.map(({ Icon, link, label }) => {
          const enhancedLink = qs.stringifyUrl({
            url: link,
            query: {
              is_master: isMaster,
              is_client: isClient,
              is_saloon_owner: isSaloonOwner,
              locale,
              timezone,
              code: code ? code : undefined,
              ym_client_id: action === "reg" ? ym_client_id : undefined,
            },
          });
          return (
            <Item variants={itemVariants} key={label}>
              <CircleButton
                greenish
                as="a"
                href={enhancedLink}
                title={label}
                large
                onClick={() => onClick(label)}
              >
                <Icon color="#fff" width="18" />
              </CircleButton>
            </Item>
          );
        })}
      </List>
    </div>
  );
};
export default Socials;
